import * as Types from 'src/actions/physical-person/change-data/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';
import PhysicalPersonData from 'src/value-objects/PhysicalPersonData';

export interface ChangePhysicalPersonData extends Action {
  type: Types.CHANGE_PHYSICAL_PERSON_DATA;
  payload: PhysicalPersonData;
}

export type ChangePhysicalPersonDataAction = ChangePhysicalPersonData;

export const changePhysicalPersonData: ActionCreator<ChangePhysicalPersonData> = (
  physicalPerson: PhysicalPersonData
) => ({
  type: Types.CHANGE_PHYSICAL_PERSON_DATA,
  payload: physicalPerson
});


// WEBPACK FOOTER //
// ./src/actions/physical-person/change-data/ChangePhysicalPersonData.actions.tsx